// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import zurl from 'zurl';

export const search_in_google = (q: string)=>{
    // @ts-ignore
    let redirect_url = zurl.qs_add('https://www.google.com/search', {q},
        {safe: true});
    location.href = redirect_url;
};
